// TabContent1.js
import { useTheme } from '@emotion/react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, ButtonBase } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import { setTabErrors } from '../../../../../newapi/global/progressionTabSlice';
import { useGetShippersSelectWithProfilesQuery } from '../../../../../newapi/shipper/shipperSlice';
import { useFindWorkspacesSelectQuery } from '../../../../../newapi/warehouse/workspaceSlice';
import { tokens } from '../../../../../theme';
import { yupNumberRequired } from '../../../../../utils/validation';
import { getShipperColorSettingsByType } from '../../../../Streams/StreamShipperSettings';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import { DropdownBase } from '../../../../theme/dropdowns/Dropdown';
import ShSwitch from '../../../../theme/inputs/ShSwitch';
import Text from '../../../../theme/text/Text';

/**
 * TabContent1 Component
 * 
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const data = { ...props.data };
    const dispatch = useDispatch();
        const [loaded, setLoaded] = useState(false);


    const [selectedWarehouseId,setSelectedWarehouseId] = useState(null);
    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);
    const { data: workSpaceData, isLoading,isFetching } = useFindWorkspacesSelectQuery();

    const { data: shippers } = useGetShippersSelectWithProfilesQuery({warehouseId: selectedWarehouseId, includeBol: false},
        {
            skip: !selectedWarehouseId
        }
    );

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    useEffect(() => {
        if(!isLoading && !isFetching && workSpaceData) {
            setSelectedWarehouseId(workSpaceData?.data?.find(workspace => workspace.id === selectedWorkSpace?.id)?.warehouseId ?? -1);
        }
    },[isLoading,isFetching,workSpaceData]);

    const selectShipper = (selected) => {
        var shipper = shippers?.filter(shipper => shipper.type !== 'bol')[selected];

        props.handleDataUpdate({shipper:shipper})
        props.handleDataUpdate({shipperId:shipper.id})
        props.handleDataUpdate({shipperProfile:null})
        props.handleDataUpdate({shipperProfileId:-1})

        dispatch(setTabErrors({ ...props.errors, shipperId: '' }));
        dispatch(setTabErrors({ ...props.errors, shipperProfileId: '' }));
    }

    const selectShipperProfile = (selected) => {
        var shipperProfile = data?.shipper?.shipperProfiles[selected];
 
        props.handleDataUpdate({shipperProfile:shipperProfile})
        props.handleDataUpdate({shipperProfileId:shipperProfile.id})
        dispatch(setTabErrors({ ...props.errors, shipperProfileId: '' }));
    }

    // Set virtual product is true for POST request
    useEffect(() => {
        if(selectedWorkSpace && !loaded) {
            props.handleDataUpdate({ selectedWorkSpaceId: selectedWorkSpace.id });
        setLoaded(true);
        }
    }, [loaded,selectedWorkSpace]);

    return (
        <Box
            sx={{
                minHeight:120,
                // height:50,
                position:'sticky',
                top:0,
                borderRadius:4,
                p:1.5,
                flex:1,
                boxShadow:`0px 2px 4px ${ (props.errors.shipperId || props.errors.shipperProfileId) ? colors.red[300] : getShipperColorSettingsByType(data?.shipper?.type).streamrulehover}`,
                border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100]}`,
                // background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                background: (props.errors.shipperId || props.errors.shipperProfileId) ? colors.red[100] : getShipperColorSettingsByType(data?.shipper?.type).background,
                transition: 'background-color 0.5s',
            }}
        >
            <Box
                sx={{
                    display:"flex",
                    alignItems:"flex-end",
                    justifyContent:'space-between',
                }}
            >
                
                <Box>
                    <Text color={tokens("white").txt["primary"]}>{t("shipper")}:</Text><br/>
                    <Text color={props.errors.shipperId ? colors.red[400] :getShipperColorSettingsByType(data?.shipper?.type).base} bold>{data?.shipper?.name ?? t("no_selection")}</Text>
                </Box> 
                <ButtonBase
                    sx={{
                        ml:2,
                        width:32,
                        height:32,
                        // background:theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt["primary"],
                        background:props.errors.shipperId ? colors.red[400] : getShipperColorSettingsByType(data?.shipper?.type).base,
                        color:props.errors.shipperId ? theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"] : getShipperColorSettingsByType(data?.shipper?.type).background,
                        borderRadius:5,
                    }}
                >
                    <DropdownBase
                        transformOrigin={{
                            vertical: "bottom"
                        }}
                        anchorOrigin={{
                            vertical:"top"
                        }}
                        displayName={"name"} 
                        onChange={(selected) => {
                            selectShipper(selected);
                        }}
                        noSelection={""} //Custom text when nothing is selected
                        options={shippers?.filter(shipper => shipper.type !== 'bol')}
                        selected={shippers?.filter(shipper => shipper.id === data?.shipperId) ?? -1}
                        closeOnSelection
                    >
                        <EditOutlinedIcon/>
                    </DropdownBase>
                </ButtonBase>
                
            </Box>
            
            <Box
                sx={{
                    mt:2,
                    display:"flex",
                    justifyContent:'space-between',
                    alignItems:'flex-end',
                }}
            >
                <Box >
                    <Text color={tokens("white").txt["primary"]}>{t("shipperprofile")}:</Text><br/>
                    <Text color={props.errors.shipperProfileId ? colors.red[400] : getShipperColorSettingsByType(data?.shipper?.type).base} bold>{data?.shipperProfile?.name ?? t("no_selection")}</Text>
                        
                </Box>
                <ButtonBase
                    sx={{
                        width:32,
                        height:32,
                        background:props.errors.shipperProfileId ? colors.red[400] : getShipperColorSettingsByType(data?.shipper?.type).base,
                        color:props.errors.shipperProfileId ? theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"] : getShipperColorSettingsByType(data?.shipper?.type).background,
                        borderRadius:5,
                    }}
                >
                    <DropdownBase
                        transformOrigin={{
                            vertical: "bottom"
                        }}
                        anchorOrigin={{
                            vertical:"top"
                        }}
                        displayName={"name"} 
                        onChange={(selected) => selectShipperProfile(selected)}
                        noSelection={""} //Custom text when nothing is selected
                        options={data?.shipper?.shipperProfiles}
                        // selected={-1}
                        selected={data?.shipper?.shipperProfiles?.filter(profile => profile.id === data?.shipperProfileId)}
                        closeOnSelection
                        // resetOnSelection
                    >
                        <EditOutlinedIcon/>
                    </DropdownBase>
                </ButtonBase>
            </Box>
        
            {props.showOptions && 
                <Box
                    sx={{
                        mt:2,
                        borderRadius:3,
                        mx:-1.5,
                        px:1.5,
                        py:1,
                        background:theme.palette.mode === "dark" ? colors.grey[400]: colors.grey[50],
                        display:"flex",
                        flexDirection:'column',
                        gap:1,
                        overflow:"hidden"
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            gap:2
                        }}
                    >
                        <Text noBreak>Print pakbon per drager</Text>
                        <ShSwitch/>
                    </Box>

                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            gap:2
                        }}
                    >
                        <Text noBreak>Print pallet pakbonnen</Text>
                        <ShSwitch/>
                    </Box>

                    <Box
                        sx={{
                            display:"flex",
                            // alignItems:"center",
                            flexDirection:'column'
                            // gap:2
                        }}
                    >
                        <Text noBreak>Print pakbon met draagnummers na voltooien order</Text>
                        <ShSwitch/>
                    </Box>
                </Box> 
            }
        </Box>
    );
};

const ShipperDetails = (props) => {
    const {t} = useTranslation();
    const schema = yup.object({
        shipperId: yupNumberRequired("shipper",t,true),
        shipperProfileId: yupNumberRequired("shipperprofile",t,true),
    });
    return (
        <ProgressionTab 
            tabId="tabOrderlines"
            subtitle={t("shipper_details")} 
            step={3}
            maxSteps={3}
            schema={schema}
        >
            <Content />
        </ProgressionTab>
    )
}

export default ShipperDetails;

